import React from 'react';
interface PrimaryButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  loading?: boolean;
  variant?: 'primary' | 'ghost';
}
export function PrimaryButton({
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  variant = 'primary'
}: PrimaryButtonProps) {
  const base = 'w-full rounded-3xl px-6 py-4 text-base font-semibold transition-all duration-200 active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-violet-400/30 disabled:cursor-not-allowed';
  const styles = variant === 'primary' ? 'bg-violet-600 text-white shadow-lift hover:bg-violet-700 disabled:bg-lavender-200 disabled:text-ink-muted disabled:shadow-none' : 'bg-transparent text-ink-soft hover:text-violet-600';
  return <button type={type} onClick={onClick} disabled={disabled || loading} className={`${base} ${styles}`} data-id="element-34" data-mp="3i6uckz0xm53d">
      <span className="inline-flex items-center justify-center gap-2" data-id="element-35" data-mp="3n6grre0blvet">
        {loading && <span aria-hidden="true" className="h-4 w-4 animate-spin rounded-full border-2 border-white/40 border-t-white" data-id="element-36" data-mp="gtjfhrewk08e" />}
        {children}
      </span>
    </button>;
}